var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIqGrey = function SvgIqGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.577 13.768c0 .445-.081.871-.23 1.264a3.567 3.567 0 0 1-6.702-.095c-2.879.207-4.525-1.078-5.21-3.527-1.728-.47-3-2.048-3-3.924 0-1.213.532-2.302 1.376-3.046a4.057 4.057 0 0 1 2.696-1.02c1.185 0 2.252.505 2.996 1.313a3.17 3.17 0 0 1 1.738-.516 3.181 3.181 0 0 1 3.185 3.137v.099a2.377 2.377 0 0 1 2.405.89c.302.4.48.895.48 1.433a2.359 2.359 0 0 1-.64 1.621c.564.63.906 1.46.906 2.37Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.203 7.199a3.913 3.913 0 0 0-1.04 2.66 3.933 3.933 0 0 0 4.77 3.842m-8.597-7.77a2.734 2.734 0 0 0 2.729 2.54m4.35-.528c.293-.242.64-.41 1.012-.49m-4.924-2.72c-.458.297-.835.71-1.088 1.197",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.577 13.768a3.562 3.562 0 0 1-3.564 3.559 3.566 3.566 0 0 1-3.368-2.39c-2.879.207-4.525-1.078-5.21-3.527-1.728-.47-3-2.048-3-3.924a4.069 4.069 0 0 1 4.072-4.066c1.185 0 2.252.505 2.996 1.313a3.183 3.183 0 0 1 4.924 2.666v.054a2.379 2.379 0 0 1 2.886 2.323c-.001.627-.244 1.196-.641 1.621.563.63.905 1.46.905 2.37Z",
    stroke: "#4A5568",
    strokeWidth: 0.81,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.673 11.397s-.277-.287-.655-.585m-9.975 7.04a3.203 3.203 0 0 1-.295-1.034",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.032 15.378c.126.349.19.717.19 1.088 0 1.909-1.677 3.455-3.747 3.455-1.535 0-2.854-.85-3.432-2.068a2.953 2.953 0 0 1-1.664.512c-1.377 0-2.539-.946-2.903-2.24-.26.064-.528.096-.796.096a3.254 3.254 0 0 1-1.182-6.286 2.602 2.602 0 0 1-.073-.613c0-1.63 1.517-2.95 3.388-2.95 1.074 0 2.033.435 2.653 1.115a3.556 3.556 0 0 1 1.683-.42c1.896 0 3.433 1.468 3.433 3.28 0 .042 0 .085-.003.127 1.565.287 2.754 1.722 2.754 3.449 0 .519-.107 1.012-.3 1.455Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.814 13.766c.559.413.986.97 1.216 1.61m-11.557.746a3.173 3.173 0 0 1-.118-.864c0-1.223.689-2.281 1.69-2.787m-2.7-2.742c-.297.03-.581.1-.849.204m5.969-2.448h0m0 0c-.426.23-.795.542-1.084.916",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.032 15.378c.126.349.19.717.19 1.088 0 1.909-1.677 3.455-3.747 3.455-1.535 0-2.854-.85-3.432-2.068a2.953 2.953 0 0 1-1.664.512c-1.377 0-2.539-.946-2.903-2.24-.26.064-.528.096-.796.096a3.254 3.254 0 0 1-1.182-6.286 2.602 2.602 0 0 1-.073-.613c0-1.63 1.517-2.95 3.388-2.95 1.074 0 2.033.435 2.653 1.115a3.556 3.556 0 0 1 1.683-.42c1.896 0 3.433 1.468 3.433 3.28 0 .042 0 .085-.003.127 1.565.287 2.754 1.722 2.754 3.449 0 .519-.107 1.012-.3 1.455Z",
    stroke: "#4A5568",
    strokeWidth: 0.81,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.648 11.447A3.24 3.24 0 0 1 15 10.422c.197 0 .388.017.575.052m-.215 4.117a2.588 2.588 0 0 1-2.025.973 2.59 2.59 0 0 1-2.008-4.225",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 16.846c0-.508-.128-.986-.354-1.404m-5.062-.249a2.958 2.958 0 0 1 1.868-1.245m-6.488-.978a2.8 2.8 0 0 1 2.617.296m2.711-2.678a1.971 1.971 0 0 1-1.928-.477m10.434.351a1.568 1.568 0 0 1 1.22-.285",
    stroke: "#4A5568",
    strokeWidth: 0.926,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.95 11.4c.37-.46.573-1.029.573-1.623a2.594 2.594 0 0 0-2.891-2.572 3.4 3.4 0 0 0-5.096-2.742 4.296 4.296 0 0 0-3.03-1.254A4.29 4.29 0 0 0 7.43 6.177c-1.806.169-3.217 1.515-3.217 3.145 0 .162.014.325.042.485a3.441 3.441 0 0 0-2.045 3.16 3.472 3.472 0 0 0 4.122 3.405c.454 1.307 1.68 2.204 3.047 2.204.555 0 1.1-.145 1.58-.422.677 1.21 2.03 1.978 3.516 1.978 1.808 0 3.335-1.128 3.808-2.665a3.778 3.778 0 0 0 4.507-3.7c0-.865-.297-1.7-.839-2.368Z",
    stroke: "#4A5568",
    strokeWidth: 1.621,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.508 2A5.477 5.477 0 0 0 6.56 5.1c-2.019.488-3.462 2.11-3.553 4.028A4.67 4.67 0 0 0 1 12.967c0 2.55 2.056 4.63 4.6 4.673a4.447 4.447 0 0 0 3.78 2.145c.394 0 .782-.052 1.159-.156.973 1.081 2.404 1.712 3.936 1.712a5.362 5.362 0 0 0 2.908-.85 4.984 4.984 0 0 0 1.66-1.744A4.989 4.989 0 0 0 24 13.768c0-.845-.212-1.666-.616-2.399a3.785 3.785 0 0 0-.732-4.244 3.785 3.785 0 0 0-2.006-1.08 4.611 4.611 0 0 0-5.909-2.996A5.502 5.502 0 0 0 11.507 2Zm0 .786c1.134 0 2.247.42 3.099 1.163a3.822 3.822 0 0 1 5.403 2.816 3.018 3.018 0 0 1 2.938 3.012c-.001.573-.165 1.133-.472 1.617.477.695.737 1.526.737 2.374a4.202 4.202 0 0 1-4.65 4.17c-.646 1.558-2.275 2.617-4.088 2.617-1.495 0-2.865-.7-3.67-1.851a3.6 3.6 0 0 1-1.425.295c-1.43 0-2.722-.856-3.317-2.162a3.896 3.896 0 0 1-4.276-3.87 3.89 3.89 0 0 1 2.012-3.405 3.226 3.226 0 0 1-.009-.24c0-1.76 1.413-3.237 3.328-3.533a4.694 4.694 0 0 1 4.39-3.003",
    fill: "#F0F0F0"
  })));
};

export default SvgIqGrey;